<template><component :is="participationComponentName" /></template>

<script>
/**
 * @module TeacherParticipationEntry
 * @desc 保留统一 Participation 路由，按 CoursePeriod 类型分发具体页面。
 */
export default {
  name: 'TeacherParticipationEntry',
  components: {
    SeminarParticipation: () => import('../Seminar/Components/Participation'),
    CapstoneParticipation: () => import('../Capstone/Components/Participation')
  },
  computed: {
    participationComponentName() {
      return this.$route.params.period === 'CP' ? 'CapstoneParticipation' : 'SeminarParticipation';
    }
  }
};
</script>
